export default "__VITE_ASSET__LCQvS2IJ__"